import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import Account from './account/account';
import Admin from './admin/admin';
import Analytics from './analytics/analytics';
import Campaigns from './campaigns/campaigns';
import Budget from './budget/budget';
import Cohorts from './cohorts/cohorts';
import Explore from './explore/explore';
import Creatives from './creatives/creatives';
import Games from './games/games';
import Segments from './segments/segments';

export default angular.module('app.components', [
  'ui.router',
  'ui.router.title',
  Account.name,
  Admin.name,
  Analytics.name,
  Campaigns.name,
  Budget.name,
  Cohorts.name,
  Explore.name,
  Creatives.name,
  Games.name,
  Segments.name
])
.config(($stateProvider, $urlRouterProvider) => {
  $urlRouterProvider.otherwise(function ($injector) {
    let $state = $injector.get("$state");
    $state.go('app.games.index');
  });
})



/** WEBPACK FOOTER **
 ** ./src/components/components.js
 **/